export const darkPalette = {
  background: {
    default: "#363330",
    paper: "#494541",
    inputField: "#4F4945",
    dropdown: "#302E2C",
  },
};
